import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
	codes: string[];
}

const PartnerCodesCard = ({ codes }: Props) => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.partner.field.codes.title")}</h5>
				<div className={"d-flex"}>
					{codes.map((code, index) => {
						return (
							<span className={"badge bg-primary me-1"} style={{ width: "fit-content" }} key={index}>
								{code}
							</span>
						);
					})}
				</div>
			</Card.Body>
		</Card>
	);
};
export default PartnerCodesCard;
